import React, { FC } from "react";
import { To, resolvePath } from "react-router";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { Link as MuiLink, type LinkProps as MuiLinkProps } from "@mui/material";

import { useSelector } from "../../store";

export interface LinkProps extends MuiLinkProps {
  to: To;
  replace?: boolean;
  reloadDocument?: boolean;
}

const Link: FC<React.PropsWithChildren<LinkProps>> = (props: LinkProps) => {
  const { organizationId, clusterId } = useSelector((state) => state.current);
  const location = useLocation();
  const { to } = props;

  const updateParams = (params: string): string => {
    const urlParams = new URLSearchParams(params);
    if (organizationId && !urlParams.has("oid")) {
      urlParams.set("oid", organizationId);
    }
    if (clusterId && !urlParams.has("cid")) {
      urlParams.set("cid", clusterId);
    }
    return urlParams.toString();
  };

  let dest: To = to;
  if (typeof to === "string") {
    const resolved = resolvePath(to, location.pathname);
    const search = updateParams(resolved.search);
    dest = {
      ...resolved,
      search: search ? "?" + search : "",
    };
  } else {
    const search = updateParams(to.search || "");
    dest = {
      ...to,
      search: search ? "?" + search : "",
    };
  }

  return <MuiLink {...props} to={dest} component={RouterLink as any} />;
};

export default Link;
